import axios from 'axios';

const API_URL = "https://afric-fresh-backend.onrender.com/product"

export const productService = {
  // Bulk create products
  bulkCreateProducts: async (products) => {
    console.log(products);
    try {
      const response = await axios.post(`${API_URL}/bulk-create`, {
        products
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
        timeout: 30000
      });

      return response.data;
    } catch (error) {
      console.log('Bulk Product Creation Error:', error);
      throw error;
    }
  },

   // Fetch product by category and name via a POST request
   getProductByCategoryAndName: async (category, name) => {
    try {
      const response = await axios.post(`${API_URL}/fetch`, {
        category,
        name
      });
      return response.data;  // Return the product data
    } catch (error) {
      console.log('Error fetching product:', error);
      throw error;
    }
  },

  // Get products by category
  getProductsByCategory: async (category) => {
    try {
      const response = await axios.post(`${API_URL}/category`, {
        category
      }, {
        timeout: 10000
      });

      return response.data;  // returns an array of products for a given category
    } catch (error) {
      console.log('Fetch Products by Category Error:', error);
      throw error;
    }
  }
};
